import authService from './authService';
import config from '../config';

let cachedUserDetails = null;

const userService = {
  getUserDetails: async (token) => {
    try {
      console.log('Fetching user details with token length:', token.length);
      
      const response = await fetch(`${config.apiBaseUrl}/api/auth/GetUserDetails`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        console.error('Failed to fetch user details:', response.status);
        throw new Error('Failed to fetch user details');
      }
      
      const data = await response.json();
      console.log('User details response:', data);
      cachedUserDetails = data;
      return data;
    } catch (error) {
      console.error('Error fetching user details:', error);
      throw error;
    }
  },

  refreshUserDetails: async () => {
    const token = await authService.getToken();
    if (!token) throw new Error('No auth token');
    return await userService.getUserDetails(token);
  },

  getCachedUserDetails: () => cachedUserDetails,

  async getSiteAdminOverview() {
    if (!authService.isAuthenticated()) {
      throw new Error('User is not authenticated');
    }
    const response = await fetch(`${config.apiBaseUrl}/api/superadmin/overview`, {
      method: 'GET',
      headers: {
        ...authService.getAuthHeaders(),
        'Content-Type': 'application/json'
      }
    });
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.error || 'Failed to fetch site admin overview');
    }
    const data = await response.json();
    return data.teams;
  },

  async deleteSiteAdminTeams(teamIds) {
    if (!authService.isAuthenticated()) {
      throw new Error('User is not authenticated');
    }
    const response = await fetch(`${config.apiBaseUrl}/api/superadmin/teams`, {
      method: 'DELETE',
      headers: {
        ...authService.getAuthHeaders(),
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ teamIds })
    });
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.error || 'Failed to delete teams');
    }
    return await response.json();
  },

  async getUserTeams() {
    if (!authService.isAuthenticated()) {
      throw new Error('User is not authenticated');
    }

    try {
      const response = await fetch(`${config.apiBaseUrl}/api/teams/user`, {
        method: 'GET',
        headers: {
          ...authService.getAuthHeaders(),
          'Content-Type': 'application/json'
        }
      });

      if (response.status === 401) {
        authService.removeToken();
        throw new Error('Authentication token is invalid or expired');
      }

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.error || 'Failed to fetch user teams');
      }

      const data = await response.json();
      if (!data.success || !Array.isArray(data.teams)) {
        throw new Error('Unexpected response format when fetching teams');
      }

      return data.teams.map(team => ({
        teamId: team.teamId,
        teamName: team.displayName || team.name,
        role: team.role,
        organizationId: team.organizationId,
        isCustomerProxy: !!team.isCustomerProxy,
        vendorTeamId: team.vendorTeamId || null
      }));
    } catch (error) {
      console.error('Error fetching user teams:', error);
      throw error;
    }
  }
};

export default userService;
